// src/config/env.config.js

export const API_BASE_URL = "https://mhblogadmin.mhcockpit.com/api";
export const ORG_SLUG = "mh-cockpit";
export const EMPLOYEE_ORG_ID = "1a1d94b9-cf5e-4f68-947e-824b83177b51";
